import styles from "./FaqSpoiler.module.css";
import { useState } from "react";
import { spoilerbtnopen, spoilerbtnclose } from "../../assets/svg/svgimages";

const FaqSpoiler = ({ spoiler }) => {
    const [isOpen, setIsOpen] = useState(false);
  
    const toggleAnswer = () => {
      setIsOpen(!isOpen);
    };
  
    return (
      <div className={styles.spoilerCont}>
        <div className={styles.question}  onClick={toggleAnswer}>
          <h4 className={`h4-medium ${isOpen? styles.active :""}`}>{spoiler.title}</h4>
          <button className="noRightPadding">
            {isOpen? spoilerbtnclose : spoilerbtnopen}
          </button>
        </div>
        {isOpen && (
          <div className={styles.answer}>
            <p dangerouslySetInnerHTML={{ __html: spoiler.text }} />
          </div>
        )}
       
      </div>
    );
  };
  
  export default FaqSpoiler;